import { render } from "./RollWindow.vue?vue&type=template&id=0540b71e&ts=true"
import script from "./RollWindow.vue?vue&type=script&lang=ts"
export * from "./RollWindow.vue?vue&type=script&lang=ts"

import "./RollWindow.vue?vue&type=style&index=0&id=0540b71e&lang=scss"

import exportComponent from "C:\\Users\\stani\\OneDrive\\Documents\\Git\\fate-extended\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__